import { render, staticRenderFns } from "./PromotionalSlider.vue?vue&type=template&id=5bcd6446&scoped=true"
import script from "./PromotionalSlider.vue?vue&type=script&lang=js"
export * from "./PromotionalSlider.vue?vue&type=script&lang=js"
import style0 from "./PromotionalSlider.vue?vue&type=style&index=0&id=5bcd6446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd6446",
  null
  
)

export default component.exports